import { Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JobDialogData } from '../../api';
import { JobDialogComponent } from './job-dialog.component';

@Injectable()
export class JobDialogService {
  constructor(private readonly dialog: MatDialog, private readonly injector: Injector) {}

  /**
   * Open the job dialog.
   * @param options if not provided will list all available jobs
   */
  open(options?: { data?: JobDialogData }) {
    return this.dialog
      .open(JobDialogComponent, {
        maxWidth: '90vw',
        width: '90vw',
        height: '90vh',
        panelClass: ['full-screen-popup'],
        ...(options ?? {}),
        injector: this.injector,
      })
      .afterClosed();
  }
}
